import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import MQTTConnection from './components/MQTTConnection';
// Remove serviceWorker import as it's not needed with Vite
// import * as serviceWorker from './serviceWorker';
import { RootStore } from './store/index';
import mainTheme from './mainTheme';
import { mqttIoTEndpoint, localMqttUrl } from './apiConfig';
import { getCookie } from './shared/utils';
import './css/omcare.css';

const token = getCookie('id_token');
// Local mosquitto broker only in dev — the local branch connects with no Cognito/SigV4/IoT policy, so never let it engage in a non-dev build even if REACT_APP_LOCAL_MQTT_URL leaks in.
const mqttHost =
  process.env.NODE_ENV === 'development' && localMqttUrl
    ? localMqttUrl
    : mqttIoTEndpoint;

interface RootProps {
  store: typeof RootStore;
}

const Root = (props: RootProps) => (
  <ThemeProvider theme={mainTheme}>
    <CssBaseline />
    <Provider store={props.store}>
      <MQTTConnection host={mqttHost} token={token ? token : ''}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MQTTConnection>
    </Provider>
  </ThemeProvider>
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<Root store={RootStore} />);
}

// Service workers are handled differently in Vite if needed
// You can add Vite PWA plugin if you need service worker functionality
